import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import moment from 'moment';
import { getFacebookAdsForPlan } from 'redux/modules/adsPlanner';
import Dialog from 'material-ui/Dialog';
import Helmet from 'react-helmet';
import RaisedButton from 'material-ui/RaisedButton';
import { AppLayout } from 'containers';
import { CardRow, AdDashboardCard, EmptyState, PageHeader, Spinner } from 'components';
var AdsPlanner = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  var adsPlanner = state.adsPlanner && state.adsPlanner["".concat(orgId)] ? state.adsPlanner["".concat(orgId)] : null;
  return {
    adsPlanner: adsPlanner,
    planAds: state.ads.planAds,
    organization: state.organization.current,
    theme: state.theme,
    loadingPlanAds: state.ads.loadingPlanAds,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null
  };
}, {
  getFacebookAdsForPlan: getFacebookAdsForPlan
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdsPlanner, _Component);

  var _super = _createSuper(AdsPlanner);

  function AdsPlanner() {
    var _this;

    _classCallCheck(this, AdsPlanner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "fetchFacebookAdsInPlan", function (plan) {
      var fields = _this.props.adsPlanner && _this.props.adsPlanner.currentPlanId && _this.props.adsPlanner[_this.props.adsPlanner.currentPlanId] ? _this.props.adsPlanner[_this.props.adsPlanner.currentPlanId].resultStatTypes : [];

      _this.props.getFacebookAdsForPlan(_this.props.organization.id, plan.id, _this.props.adAccount.adAccountId, fields);
    });

    _defineProperty(_assertThisInitialized(_this), "renderCategorySeperatedCards", function () {
      var categories = ['POST_ENGAGEMENT', 'LEADS', 'PAGE_LIKES', 'WEBSITE_TRAFFIC'].map(function (type, idx) {
        var ads = _this.props.planAds && _this.props.planAds.ads ? _toConsumableArray(_this.props.planAds.ads).filter(function (ad) {
          switch (type) {
            case 'LEADS':
              return ad.campaign.objective === 'LEAD_GENERATION';

            case 'PAGE_LIKES':
              return ad.campaign.objective === 'PAGE_LIKES';

            case 'WEBSITE_TRAFFIC':
              return ad.campaign.objective === 'LINK_CLICKS';

            case 'POST_ENGAGEMENT':
              return ad.campaign.objective === 'POST_ENGAGEMENT';

            default:
              return false;
          }
        }) : [];

        if (ads.length > 0) {
          return /*#__PURE__*/React.createElement(CardRow, {
            key: idx,
            title: type.toLowerCase().replace(/_/g, ' '),
            items: ads.map(function (ad, index) {
              return /*#__PURE__*/React.createElement(AdDashboardCard, _defineProperty({
                key: index,
                type: type,
                adDetails: ad
              }, "key", ad.id));
            }),
            itemWidth: 361,
            rowHeight: 300
          });
        }

        return null;
      }).filter(function (r) {
        return r;
      });

      if (categories.length > 0) {
        return categories;
      }

      return /*#__PURE__*/React.createElement(EmptyState, {
        text: "You haven't created any ads in this plan yet.",
        iconName: "ion-android-expand",
        iconSize: "95px"
      });
    });

    return _this;
  }

  _createClass(AdsPlanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var plan = this.props.adsPlanner && this.props.adsPlanner.currentPlanId ? this.props.adsPlanner[this.props.adsPlanner.currentPlanId] : null;

      if (this.props.adAccount && plan) {
        this.fetchFacebookAdsInPlan(plan);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevProps.adAccount && this.props.adAccount) {
        var plan = this.props.adsPlanner && this.props.adsPlanner.currentPlanId ? this.props.adsPlanner[this.props.adsPlanner.currentPlanId] : null;
        this.fetchFacebookAdsInPlan(plan);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "Advertising - All Ads"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 36px'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Advertising",
        secondary: "All Ads",
        pageTitleStyle: {
          marginTop: 0
        }
      }), this.props.adAccount && /*#__PURE__*/React.createElement(Link, {
        to: {
          pathname: "/org/".concat(this.props.organization.id, "/create-ad/1"),
          state: {
            modal: true
          }
        },
        style: {
          marginTop: 22,
          marginRight: 16
        }
      }, this.props.adAccount && /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Create Ad"
      }))), (this.props.loadingAdAccount || this.props.loadingPlanAds) && !this.props.planAds && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), !this.props.loadingAdAccount && !this.props.adAccount && /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Connect Ad Account",
        buttonOnClick: function buttonOnClick() {
          browserHistory.push("/org/".concat(_this2.props.organization.id, "/settings/social-accounts"));
        },
        text: "Nothing to see here...until you connect your ad account.",
        iconName: "ion-map",
        iconSize: "95px"
      }), this.props.planAds && !!this.props.planAds.length && this.renderCategorySeperatedCards()));
    }
  }]);

  return AdsPlanner;
}(Component)) || _class);
export { AdsPlanner as default };